module.exports = __webpack_public_path__ + "static/img/loading.a19d4d3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/loading.gif
// module id = c0nJ
// module chunks = 1